// ============================================================================
//  订单/支付模块 API
// ============================================================================

import { Request as request } from "@/utils/request";

/**
 * 创建 Stars 订单
 * @param {string} id - 任务 ID
 * @returns {Promise<{ code: number, data: { order_id: string, url: string } }>}
 */
export const createStarsOrder = (id) => {
  return request("/api/common_v1/stars-create-order", {
    method: "POST",
    params: { id },
  });
};

/**
 * 创建 Stars 订单 V3
 * @param {string} id - 任务 ID
 */
export const createStarsOrder3 = (id) => {
  return request("/api/common_v3/stars-create-order", {
    method: "POST",
    params: { id },
  });
};

/**
 * 检查 Stars 订单状态
 * @param {string} order_id - 订单号
 * @returns {Promise<{ code: number, data: "wait" | "success" }>}
 */
export const checkStarsOrderStatus = (order_id) => {
  return request("/api/common_v3/stars-check-order", {
    method: "POST",
    params: { order_id },
  });
};

/**
 * 获取分享信息
 */
export const fetchShareinfo = (params) => {
  return request("/api/common/fetch-shareinfo", {
    method: "GET",
    params,
  });
};
